module.exports = __webpack_public_path__ + "img/cover-avon.06ae63aa.jpg";